import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Moment from "react-moment";
import InvoiceService from "services/InvoiceService";
import InvoiceCreatePayment from "pages/invoices/paymentHistories/Create";
import { Activities } from "components/utils/Activities";
import ClientInvoiceService from "services/clientServices/ClientInvoiceService";
import InvoicePartItems from "pages/invoices/partItems/Index";
const ShowInvoice = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState({});
  const [paymentHistories, setPaymentHistories] = useState([]);
  const [block, setBlock] = useState(false);
  const [active, setActive] = useState("part_items"); // * tab active or not
  const [tab, setTab] = useState("part_items");
  const [open, setOpen] = useState(false); //* open modal
  const getInvoice = async () => {
    let res = await ClientInvoiceService.get(id);
    setInvoice(res);
  };

  const getPaymentHistories = async () => {
    let res = await InvoiceService.getPaymentHistories(id);
    setPaymentHistories(res.data);
  };
  const onCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (id) getInvoice();
    getPaymentHistories();
  }, [id]);
  return (
    <>
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="row">
            <div className="col-xl-3">
              <div className="card card-custom">
                <div className="card-header">
                  <div className="card-title">
                    <h3 className="card-label">
                      <button
                        className="btn btn-sm btn-dark "
                        style={{ marginRight: "0.75rem" }}
                        onClick={() => navigate(-1)}
                      >
                        <i className="fa fa-arrow-left"></i>Back
                      </button>
                      Details
                    </h3>
                  </div>
                </div>

                <div className="card-body py-4">
                  <div className="fw-bolder mt-5">Invoice Number</div>
                  <div className="text-gray-600">{invoice?.invoice_number}</div>
                  <div className="fw-bolder mt-5">Invoice Status</div>
                  {invoice?.requisition?.type !== "claim_report" ? (
                    <>
                      <div className="text-gray-600">
                        {invoice?.part_items?.reduce(
                          (partialSum, a) =>
                            partialSum + parseInt(a.total_value),
                          0
                        ) ==
                        paymentHistories?.reduce(
                          (partialSum, a) => partialSum + parseInt(a.amount),
                          0
                        ) ? (
                          <span className="badge badge-light-success">
                            Paid
                          </span>
                        ) : invoice?.part_items?.reduce(
                            (partialSum, a) =>
                              partialSum + parseInt(a.total_value),
                            0
                          ) >
                          paymentHistories?.reduce(
                            (partialSum, a) => partialSum + parseInt(a.amount),
                            0
                          ) ? (
                          <span className="badge badge-light-warning">
                            Partial Paid
                          </span>
                        ) : paymentHistories?.reduce(
                            (partialSum, a) => partialSum + parseInt(a.amount),
                            0
                          ) == 0 ? (
                          <span className="badge badge-light-danger">
                            {" "}
                            UnPaid
                          </span>
                        ) : (
                          <span className="badge badge-light-danger"> </span>
                        )}
                      </div>
                    </>
                  ) : (
                    "--"
                  )}

                  <div className="fw-bolder mt-5">Invoice Date</div>
                  <div className="text-gray-600">
                    <Moment format="D MMMM YYYY">
                      {invoice?.invoice_date}
                    </Moment>
                  </div>

                  <div className="fw-bolder mt-5">Payment Mode</div>
                  <div className="text-gray-600">
                    {invoice?.payment_mode ?? "--"}
                  </div>

                  <div className="fw-bolder mt-5">Payment Term</div>
                  <div className="text-gray-600">
                    {invoice?.payment_term ?? "--"}
                  </div>

                  <div className="fw-bolder mt-5">Payment Partial Mode</div>
                  <div className="text-gray-600">
                    {invoice?.payment_partial_mode ?? "--"}
                  </div>
                  <div className="fw-bolder mt-5">Next Payment </div>
                  <div className="text-gray-600">
                    {invoice?.next_payment ?? "--"}
                  </div>

                  <div className="fw-bolder mt-5">Last Payment </div>
                  <div className="text-gray-600">
                    {invoice?.last_payment ?? "--"}
                  </div>

                  <div className="fw-bolder mt-5">Priority</div>
                  <div className="text-gray-600">
                    {invoice?.requisition?.priority?.capitalize()}
                  </div>

                  <div className="fw-bolder mt-5">Requisition Type</div>
                  <div className="text-gray-600">
                    {invoice?.requisition?.type
                      ?.replaceAll("_", " ")
                      ?.capitalize()}
                  </div>

                  <div className="fw-bolder mt-5">Requisition Ref Number</div>
                  <div className="text-gray-600">
                    {invoice?.requisition?.ref_number ?? "--"}
                  </div>

                  <div className="fw-bolder mt-5">Sub Total </div>
                  <div className="text-gray-600">
                    {invoice?.sub_total ?? "0"}tk
                  </div>

                  <div className="fw-bolder mt-5">Vat </div>
                  <div className="text-gray-600">{invoice?.vat ?? "0"}%</div>

                  <div className="fw-bolder mt-5">Discount </div>
                  <div className="text-gray-600">{invoice?.discount ?? "0"}%</div>

                  <div className="fw-bolder mt-5">Grand Total</div>
                  <div className="text-gray-600">
                    {invoice?.grand_total ?? "0"}tk
                  </div>

                  <div className="fw-bolder mt-5">Created At </div>
                  <div className="text-gray-600">
                    <Moment format="D MMMM YYYY">
                      {invoice?.invoice_date}
                    </Moment>
                  </div>
                </div>
                <div className="card-header">
                  <div className="card-title">
                    <h3 className="card-label">
                      <Link
                        className="btn btn-sm btn-dark "
                        to={"/panel/client/invoices/" + invoice.id + "/print"}
                        style={{ marginRight: "0.75rem" }}
                        target="_blank"
                      >
                        Print
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-9">
              <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-n2">
                  <li className="nav-item">
                    <a
                      className="nav-link text-active-primary pb-4 active"
                      data-bs-toggle="tab"
                      href="#part_items"
                      onClick={() => {
                        setActive("part_items");
                        setTab("part_items");
                      }}
                    >
                      Part Items
                    </a>
                  </li>
                  {invoice?.requisition?.type !== "claim_report" ? (
                    <li className="nav-item">
                      <a
                        className="nav-link text-active-primary pb-4"
                        data-bs-toggle="tab"
                        href="#payment_histories"
                        onClick={() => {
                          setActive("payment_histories");
                        }}
                      >
                        Payment Histories
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  <li className="nav-item">
                    <a
                      className={`nav-link text-active-primary pb-4 ${
                        tab == "activities" ? "active" : ""
                      }`}
                      data-bs-toggle="tab"
                      href="#activities"
                      onClick={() => setTab("activities")}
                    >
                      Activities
                    </a>
                  </li>
                </ul>

                <div className="tab-content">
                  {/* Tabs start from here */}

                  <InvoicePartItems
                    active={active}
                    invoice={invoice}
                    tab={tab}
                  />
                  <Activities logName="invoices" modelId={id} tab={tab} />
                  <div
                    className={`tab-pane fade ${
                      tab == "payment_histories" ? "active show" : ""
                    }`}
                    id="payment_histories"
                    role="tab-panel"
                  >
                    <div className="d-flex flex-column gap-7 gap-lg-10">
                      <div className="card card-flush py-4">
                        <div className="card-header">
                          <div className="card-title">
                            <h2>Payment Histories</h2>
                          </div>
                          <div className="card-toolbar"></div>
                        </div>
                        <div className="card-body pt-0">
                          <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                              <tr className="fw-bolder text-muted">
                                <th className="min-w-80px">Invoice Id</th>
                                <th className="min-w-120px">payment Mode</th>
                                <th className="min-w-120px">Payment Date</th>
                                <th className="min-w-120px">Amount</th>
                                <th className="min-w-150x">Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {paymentHistories?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.invoice?.invoice_number}</td>
                                  <td>{item.payment_mode}</td>

                                  <td>
                                    <Moment format="YYYY-MM-DD">
                                      {item.payment_date}
                                    </Moment>
                                  </td>
                                  <td>{item?.amount}Tk.</td>

                                  <td>
                                    <span className="text-end">
                                      <Link
                                        to={
                                          `/panel/invoices/` +
                                          item?.invoice?.id +
                                          `/payment-histories/` +
                                          item.id
                                        }
                                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                      >
                                        <i className="fa fa-eye"></i>
                                      </Link>
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <InvoiceCreatePayment
        open={open}
        onCloseModal={onCloseModal}
        invoice={invoice}
      />
    </>
  );
};

export default ShowInvoice;
